import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import bgButton from "../../../../assets/images/Event-2025/bg-button.png";
import iconLeft from "../../../../assets/images/Event-2025/arrow-left.svg";
import iconHistory from "../../../../assets/images/Event-2025/icon-history.svg";
import iconRule from "../../../../assets/images/Event-2025/icon-info.svg";
import _ from "lodash";
import iconBid from "../../../../assets/images/Event-2025/icon-total-bid.svg";
import iconTotalBid from "../../../../assets/images/Event-2025/icon-total-super.svg";
import iconButtonDetail from "../../../../assets/images/Event-2025/icon-button-detail.svg";
import PopupCommon from "./Popup/PopupCommon";
import { POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT } from "../../../../helper/const";
import {
  curStateAccount,
  curStateEventThingyan2025,
} from "../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { getConfigEventThingyan } from "../../../../Redux/futures/thingyan-2025/action";

export default function HeaderAction() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [idVariant, setIdVariant] = useState(null);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const selectorAccount = useSelector(curStateAccount);

  useEffect(() => {
    if (selectorAccount.userInfo) {
      dispatch(getConfigEventThingyan());
    }
  }, [selectorAccount.userInfo]);

  const dataSpinApiRedux = useSelector(
    curStateEventThingyan2025
  )?.configEventThingyan;
  const dataSpinSet = useSelector(curStateEventThingyan2025)?.dataSpinLeft;

  const dataSpin = !_.isEmpty(dataSpinSet)
    ? dataSpinSet
    : dataSpinApiRedux || {};

  const data = [
    { id: 1, icon: iconLeft },
    { id: VARIANT.activityHistory, icon: iconHistory },
    { id: VARIANT.rule, icon: iconRule },
  ];

  const handleAction = (id) => {
    switch (id) {
      case 1:
        return navigate(-1);
      default:
        setIsShowPopup(true);
        return setIdVariant(id);
    }
  };

  useEffect(() => {
    if (idVariant === VARIANT.activityHistory && isShowPopup) {
    }
  }, [isShowPopup, idVariant]);

  return (
    <Container Bg={iconButtonDetail}>
      <div className="action-event">
        {data.map((item) => {
          return (
            <div
              key={item.id}
              className="container-bg-action scale-hover-item"
              onClick={() => handleAction(item.id)}
            >
              <img src={bgButton} alt="" />
              <img src={item.icon} alt="" className="bg-action-thingyan" />
            </div>
          );
        })}
      </div>
      <div className="detail-event">
        <div
          className={`event-bid ${
            dataSpin.spin_left + dataSpin.spin_left_free > 10 &&
            dataSpin.spin_left + dataSpin.spin_left_free < 99
              ? "event-bid-small"
              : dataSpin.spin_left + dataSpin.spin_left_free > 99
              ? "event-bid-big"
              : ""
          }`}
        >
          <img src={iconBid} alt="" className="icon-bid-event" />
          <div className="number-total">
            {dataSpin.spin_left + dataSpin.spin_left_free || 0}
          </div>
        </div>
        <div
          className={`event-bid ${
            dataSpin.spin_left + dataSpin.spin_left_free > 10 &&
            dataSpin.spin_left + dataSpin.spin_left_free < 99
              ? "event-bid-small"
              : dataSpin.spin_left + dataSpin.spin_left_free > 99
              ? "event-bid-big"
              : ""
          }`}
        >
          <img src={iconTotalBid} alt="" className="icon-bid-event" />
          <div className="number-total">{dataSpin.spin_left_super || 0}</div>
        </div>
      </div>
      {isShowPopup ? (
        <PopupCommon
          isOpenPopup={isShowPopup}
          handleCancel={() => setIsShowPopup(false)}
          variant={idVariant}
        />
      ) : null}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 12px 18px;
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
  z-index: 2;

  .event-bid {
    height: 48px;
    background-image: url(${(props) => props.Bg});
    background-size: contain; /* Đảm bảo ảnh không bị cắt */
    background-position: center;
    background-repeat: no-repeat;
    width: 95px;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .event-bid-small {
    width: 104px;
  }

  .event-bid-big {
    width: 115px;
  }

  .number-total {
    color: white;
    font-size: 24px;
    font-weight: 700;
  }

  .detail-event {
    display: flex;
    gap: 20px;
  }

  .action-event {
    display: flex;
    gap: 8px;
    justify-content: left;

    .container-bg-action {
      position: relative;
      width: 48px;
      height: 48px;
      cursor: pointer;
    }

    .bg-action-thingyan {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 30px;
      height: 30px;
      transform: translate(-50%, -50%);
    }
  }

  @media (max-width: 576px) {
    margin: 8px;
    margin-bottom: 0;

    .number-total {
      font-size: 18px;
    }

    .event-bid {
      height: 34px;
      width: 87px;

      .icon-bid-event {
        height: 34px;
      }
    }

    .detail-event {
      gap: 8px;
    }

    .action-event {
      .container-bg-action {
        width: 34px;
        height: 34px;
        /* height: 48px; */
      }

      .bg-action-thingyan {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
